export default __webpack_public_path__ + "static/media/bs4.3c2604e2.png";